<template>

    <!-- product discounts -->
    <div class="bg-white overflow-hidden shadow rounded-lg relative pb-20">

        <div class="flex p-5 items-center">
            <h2 class="flex-1 text-lg font-medium leading-6 text-gray-900">
                Product Discounts
            </h2>
            <button class="btn-outline text-xs ml-2" @click.prevent="" v-show="false">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
            </button>
            <button class="btn-outline text-xs ml-2" @click.prevent="" v-show="false">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                </svg>
            </button>
            <button class="btn-outline text-xs ml-2" @click.prevent="toggleProductSearchSelector">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                </svg>
            </button>
        </div>

        <ProductSearchSelector :data="product.products.data" v-show="product_search" @closeModal="toggleProductSearchSelector" @selectProduct="selectProduct"></ProductSearchSelector>

        <div class="px-5">
            <p class="text-sm text-gray-500 mb-4">
                Set product discounts for this account (overrides any cost index associated with account).
            </p>

            <div class="h-60 overflow-y-scroll"  v-if="value.hasDiscounts()">
                <table class="w-full">
                    <tbody>
                    <tr class="colored-row" v-for="(item, index) in value.account_discounts">
                        <td class="w-4/6 px-3 py-1 text-sm">
                            <div class="flex-1 form-control text-gray-600">
                                <span class="font-medium">{{ item.product.name }}</span><br>
                                <span class="text-xs text-gray-400">{{ item.sku }}</span>
                            </div>
                        </td>
                        <td class="w-1/6 px-3 py-1 text-center text-sm text-gray-500">
                            <div class="flex items-center form-control col-span-6 xl:col-span-4">
                                <input type="text" name="discount" id="discount" class="text-center" v-model="item.discount" @change="updateProductDiscount(item)"><span class="font-medium text-lg ml-1">%</span>
                            </div>
                        </td>
                        <td class="w-1/6 px-3 py-1 text-gray-500">


                            <ConfirmationModal button_classes="btn-error text-sm justify-center px-6" button_text="Delete Account" @confirmModal="removeProductDiscount(item)">
                                <template v-slot:clickable="{ toggleModal }">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 cursor-pointer mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" @click="toggleModal">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                    </svg>
                                </template>
                                <div class="mt-3 text-center sm:mt-5">
                                    <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                                        Remove Product Discount?
                                    </h3>
                                    <h4 class="text-lg leading-6 font-medium text-gray-400 mt-2">
                                        {{ item.product.name }}
                                    </h4>
                                    <div class="mt-2">
                                        <p class="text-sm text-gray-500">
                                            Are you sure you would like to remove the product discount? Deleting this
                                            setting will result in the product receiving the default discount minus any
                                            cost index calculations.
                                        </p>
                                    </div>
                                </div>
                            </ConfirmationModal>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="flex h-60 items-center justify-center" v-else>
                <h2 class="text-gray-600 font-medium text-lg text-center">No Product Discounts</h2>
            </div>

        </div>

        <div class="flex bg-gray-50 px-5 py-3 text-sm text-gray-400 absolute bottom-0 left-0 right-0">
            <p class="w-1/2">

            </p>
            <p class="flex w-1/2 justify-end items-center text-xs">
                <span class="font-medium">{{ value.account_discounts.length }}&nbsp;</span> discount overrides set
            </p>
        </div>
    </div>

</template>

<script>
import ConfirmationModal from "../Support/ConfirmationModal";
import ProductSearchSelector from "../Product/ProductSearchSelector";

export default {
    props: {
        value: {
            required: true
        },
        product: {
            required: true,
        },
        allow_imports: {
            type: Boolean,
            required: false,
            default: false
        },
        allow_exports: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    name: "AccountDiscounts",
    data() {
        return {
            product_search: false
        }
    },
    components: {
        ConfirmationModal,
        ProductSearchSelector
    },
    methods: {
        selectProduct(event) {
            let vm = this;

            vm.value.addProductDiscount(event).then(result => vm.toggleProductSearchSelector());
        },
        updateProductDiscount(item) {
            let vm = this;

            vm.value.updateProductDiscount(item);
        },
        removeProductDiscount(item) {
            let vm = this;

            vm.value.removeProductDiscount(item);
        },
        toggleProductSearchSelector() {
            this.product_search = ! this.product_search;
        },
    }
}
</script>


